import Vue from 'vue';
import all from './all';
import store from '../../store';

const success = (resolve, id) => {
  store.dispatch('removeRecipeProcedure', id);
  all();
  resolve();
};

const failed = (error, reject) => {
  reject(error);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/production/recipe_procedure/${id}`)
    .then(() => {
      success(resolve, id);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeProcedure/destroy.js